import { type HttpResponseResolver, HttpResponse } from 'msw';
import {
  categoryOptions,
  categoryOptionsWithEarmarking,
} from './__mocks__/category-options';
import { contextualDatasets } from './__mocks__/contextual-datasets';
import { fundingSourceOptions } from './__mocks__/funding-source-options';
import { levelOptions } from './__mocks__/level-options';
import { years } from './__mocks__/years';

export const mockOptionsEndpoint: HttpResponseResolver<{
  dataset: string;
}> = ({ params }) => {
  const dataset = params.dataset;
  const isMonthly = ['CNT'].includes(dataset);
  return HttpResponse.json({
    levels: levelOptions,
    categories: isMonthly ? categoryOptionsWithEarmarking : categoryOptions,
    fundingSources: isMonthly ? fundingSourceOptions : null,
    contextualDatasets,
    years,
    isMonthly,
  });
};
